import { ActionTypes as PageActionTypes } from '../../actions/data';
export const initialState = [];
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PageActionTypes.CATEGORY_TREE_HYDRATE:
        case PageActionTypes.CATEGORY_TREE_REQUEST_SUCCESS: {
            return action.payload.data.categories.map((c) => c.id);
        }
    }
    return state;
};
export default reducer;
//# sourceMappingURL=topLevelcategoryIds.js.map